import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { CustomValidatorService } from 'src/app/shared/services/custom-validator.service';
import { UserModuleConsts } from '../../constants';
import { AuthLoginService } from '../../services/auth-login.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { SharedConsts } from 'src/app/shared/constants';


@Component({
    selector: 'sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
    standalone: false
})
export class SignUpComponent implements OnInit {
  signupForm: FormGroup;
  submitted = false;
  errMessage: any;
  constructor(private statePersistService: StatePersistService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private customValidator: CustomValidatorService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: AuthLoginService,
    private toastService: AlertService,
    private renderer: Renderer2,
    private recaptchaV3Service: ReCaptchaV3Service,) { }

  ngOnInit(): void {
    this.signupForm = this.formBuilder.group({
      account_number:['', Validators.maxLength(50)],
      store_name:['', [Validators.required, Validators.maxLength(30)]],
      number_of_stores:['', [Validators.required, Validators.pattern(UserModuleConsts.NUMERIC), Validators.min(1), Validators.max(999)]],
      first_name:['', [Validators.required, Validators.maxLength(30)]],
      last_name:['', [Validators.required, Validators.maxLength(30)]],
      postcode:['', [Validators.required, Validators.pattern(UserModuleConsts.POST_CODE), Validators.maxLength(15)]],
      contact_number:['', [Validators.required, Validators.pattern(UserModuleConsts.PHONE_NUMBER_NUMERIC), Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email, this.customValidator.emailValidator]],
    });
  }

  signupSubmit(){
    var fields = this.signupForm.controls
    var dataObj = new Object
    dataObj['first_name'] = fields.first_name.value
    dataObj['last_name'] = fields.last_name.value
    dataObj['email'] = fields.email.value
    dataObj['account_number'] = fields.account_number.value
    dataObj['store_name'] = fields.store_name.value
    dataObj['number_of_stores'] = fields.number_of_stores.value
    dataObj['postcode'] = fields.postcode.value
    dataObj['contact_number'] = fields.contact_number.value
    this.recaptchaV3Service.execute('importantAction')
    .subscribe(() => {
      this.userService.retailerSignup(dataObj)
    .subscribe(
      data => {
          this.googleAnalyticsService.eventEmitter(SharedConsts.SIGNUP_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.SIGNUP_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
          if (data['status'] === 1176){
            this.toastService.success(data.response);
          }
          else{
            this.toastService.success('Your signup request submitted successfully');
            
          }
          this.router.navigate(['/users/login']);
          
        },
        error => {
          this.googleAnalyticsService.eventEmitter("signup_fail", SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, "signup fail", SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
        }
      );
    });
    
  }

  oNEmailChange(){
    this.errMessage = ''
  }

  EmailExistOrNot() {
    this.submitted = true;

    if (this.signupForm.invalid) {
      return;
    }
    this.errMessage = '';
    var fields = this.signupForm.controls
    this.userService.userExistOrNot({"email": fields.email.value})
      .subscribe(
        data => {
          if (data.status === 111){
            this.errMessage = data.message;
          }
          else{
            this.errMessage = '';
            this.signupSubmit()
          }
          
        },
        error => {
         
        }
      );
  }
}
